import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { MinesweeperGame } from './MinesweeperGame';

export function MinesweeperEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  return <MinesweeperGame {...props} />;
}
